import { Component, Fragment } from 'react'
// Nodes
import Button from '../../Nodes/Button'
import Container from '../../Nodes/Container'
import CustomIcon from '../../Nodes/CustomIcon'
import Icon from '../../Nodes/Icon'
import Menu from '../../Nodes/Menu'
import Section from '../../Nodes/Section'
import Select from '../../Nodes/Select'
import TextArea from '../../Nodes/TextArea'
import TextField from '../../Nodes/TextField'
import Toggle from '../../Nodes/Toggle'
import { 
    H1, H2, H3, H4, H5, H6, 
    Subtitle1, Subtitle2, 
    Body1, Body2, 
    Caption, ButtonText, Overline 
} from '../../Nodes/Typography'
// Widgets
import ArticleList from '../../Widgets/ArticleList'
import Carousel from '../../Widgets/Carousel'
import CDLMap from '../../Widgets/CDLMap'
import CodeDisplay from '../../Widgets/CodeDisplay'
import Collapse from '../../Widgets/Collapse'
import ContentDisplay from '../../Widgets/ContentDisplay'
import Dialog from '../../Widgets/Dialog'
import Loader from '../../Widgets/Loader'
import ImageLink from '../../Widgets/ImageLink'
import Notification from '../../Widgets/Notification'
import Popup from '../../Widgets/Popup'
import Fab from '../../Widgets/Fab'
import Share from '../../Widgets/Share'
import Snackbar from '../../Widgets/Snackbar'
import Tabs from '../../Widgets/Tabs'
import Tab from '../../Widgets/Tabs/Tab'
// Features 
import Contact from '../../Features/Contact'
import Faq from '../../Features/Faq'
import EditButton from '../../Features/EditButton'
import EmailOptin from '../../Features/EmailOptin'
import CheckSubscription from '../../Features/CheckSubscription'

class StyleGuideAtoms extends Component {
    render() {
        return (
            <Fragment>
                <Section>
                    <Container>
                        <H1>Atoms</H1>
                        <Body1>
                            Atoms Represent the fundamental building blocks of a site. When something can't be separated into smaller parts, it's an atom. In general, these aren't features to be used with in the site; mainly they are representative of a single CSS style rule which is applied globally to the site.
                        </Body1>
                    </Container>
                </Section>
                <Section id="style-guide__atoms__colours">
                    <Container>
                        <H3>Colours</H3>             
                        <div className="grid">
                            <div className="grid__cell--6">
                                <div className="style-guide__color style-guide__color--primary"></div>
                            </div>
                            <div className="grid__cell--6">
                                <div className="style-guide__color style-guide__color--secondary"></div>
                            </div>
                            <div className="grid__cell--6">
                                <div className="style-guide__color style-guide__color--background"></div>
                            </div>
                            <div className="grid__cell--6">
                                <div className="style-guide__color style-guide__color--dark"></div>
                            </div>
                        </div>           
                    </Container>
                </Section>
                <Section id="style-guide__atoms__spacing">
                    <Container>
                        <H3>Spacing</H3>
                        <Body1 className="style-guide__spacing style-guide__spacing--padding-quarter"></Body1>
                        <Body1 className="style-guide__spacing style-guide__spacing--padding-half"></Body1>
                        <Body1 className="style-guide__spacing style-guide__spacing--padding-minus"></Body1>
                        <Body1 className="style-guide__spacing style-guide__spacing--padding"></Body1>
                        <Body1 className="style-guide__spacing style-guide__spacing--padding-plus"></Body1>
                        <Body1 className="style-guide__spacing style-guide__spacing--padding-double"></Body1>
                        <Body1 className="style-guide__spacing style-guide__spacing--padding-triple"></Body1>
                    </Container>
                </Section>
                <Section id="style-guide__atoms__elevation">
                    <Container>
                        <H3>Elevation (Box-Shadow)</H3>
                        <div className="grid">
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--1">1dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--2">2dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--3">3dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--4">4dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--5">5dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--6">6dp</Body1>

                            <Body1 className="grid__cell--2 style-guide__elevation elevation--7">7dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--8">8dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--9">9dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--10">10dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--11">11dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--12">12dp</Body1>

                            <Body1 className="grid__cell--2 style-guide__elevation elevation--13">13dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--14">14dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--15">15dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--16">16dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--17">17dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--18">18dp</Body1>
                            
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--19">19dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--20">20dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--21">21dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--22">22dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--23">23dp</Body1>
                            <Body1 className="grid__cell--2 style-guide__elevation elevation--24">24dp</Body1>
                        </div>
                        <CodeDisplay html={
`.elevation--1
.elevation--2
.elevation--3
.elevation--4
.elevation--5
.elevation--6
.elevation--7
.elevation--8
.elevation--9
.elevation--10
.elevation--11
.elevation--12
.elevation--13
.elevation--14
.elevation--15
.elevation--16
.elevation--17
.elevation--18
.elevation--19
.elevation--20
.elevation--21
.elevation--22
.elevation--23
.elevation--24`} />
                    </Container>
                </Section>
                <Section id="style-guide__atoms__fonts">
                    <Container>
                        <H3>Fonts</H3>
                        <Subtitle1>Avenir</Subtitle1>
                        <div className="style-guide__font font--avenir-light">Avenir LT W01_35 Light1475496</div>
                        <CodeDisplay html={`.font--avenir-light`} />
                        <div className="style-guide__font font--avenir-light-alt">Avenir LT W01_35 Light 1475502</div>
                        <CodeDisplay html={`.font--avenir-light-alt`} />
                        {/* <div className="style-guide__font font--avenir-book">Avenir LT W01_45 Book1475508</div>
                        <CodeDisplay html={`.font--avenir-book`} />
                        <div className="style-guide__font font--avenir-book-alt">Avenir LT W01_45 Book O1475514</div>
                        <CodeDisplay html={`.font--avenir-book-alt`} /> */}
                        <div className="style-guide__font font--avenir-roman">Avenir LT W01_55 Roman1475520</div>
                        <CodeDisplay html={`.font--avenir-roman`} />
                        <div className="style-guide__font font--avenir-oblique">Avenir LT W01_55 Obliqu1475526</div>
                        <CodeDisplay html={`.font--avenir-oblique`} />
                        {/* <div className="style-guide__font font--avenir-medium">Avenir LT W01_65 Medium1475532</div>
                        <CodeDisplay html={`.font--avenir-medium`} />
                        <div className="style-guide__font font--avenir-medium-alt">Avenir LT W01_65 Medium1475538</div>
                        <CodeDisplay html={`.font--avenir-medium-alt`} /> */}
                        <div className="style-guide__font font--avenir-heavy">Avenir LT W01_85 Heavy1475544</div>
                        <CodeDisplay html={`.font--avenir-heavy`} />
                        <div className="style-guide__font font--avenir-heavy-alt">Avenir LT W01_85 Heavy 1475550</div>
                        <CodeDisplay html={`.font--avenir-heavy-alt`} />
                        <div className="style-guide__font font--avenir-black">Avenir LT W01_95 Black1475556</div>
                        <CodeDisplay html={`.font--avenir-black`} />
                        <div className="style-guide__font font--avenir-black-alt">Avenir LT W01_95 Black 1475562</div>
                        <CodeDisplay html={`.font--avenir-black-alt`} />
                        <hr/>
                        <Subtitle1>Optima</Subtitle1>
                        {/* <div className="style-guide__font font--optima-roman">Optima LT W01 Roman</div>
                        <CodeDisplay html={`.font--optima-roman`} />
                        <div className="style-guide__font font--optima-italic">Optima LT W01 Italic</div>
                        <CodeDisplay html={`.font--optima-italic`} />
                        <div className="style-guide__font font--optima-medium">Optima LT W01 Medium</div>
                        <CodeDisplay html={`.font--optima-medium`} />
                        <div className="style-guide__font font--optima-medium-italic">Optima LT W01 Medium Italic</div>
                        <CodeDisplay html={`.font--optima-medium-italic`} />
                        <div className="style-guide__font font--optima-demi-bold">Optima LT W01 Demi Bold</div>
                        <CodeDisplay html={`.font--optima-demi-bold`} />
                        <div className="style-guide__font font--optima-demi-bold-italic">Optima LT W01 Demi Bold Italic</div>
                        <CodeDisplay html={`.font--optima-demi-bold-italic`} /> */}
                        <div className="style-guide__font font--optima-bold">Optima LT W01 Bold</div>
                        <CodeDisplay html={`.font--optima-bold`} />
                        <div className="style-guide__font font--optima-bold-italic">Optima LT W01 Bold Italic</div>
                        <CodeDisplay html={`.font--optima-bold-italic`} />
                        {/* <div className="style-guide__font font--optima-black">Optima LT W01 Black</div>
                        <CodeDisplay html={`.font--optima-black`} />
                        <div className="style-guide__font font--optima-black-italic">Optima LT W01 Black Italic</div>
                        <CodeDisplay html={`.font--optima-black-italic`} />
                        <div className="style-guide__font font--optima-extra-black">Optima LT W01 Extra Black</div>
                        <CodeDisplay html={`.font--optima-extra-black`} />
                        <div className="style-guide__font font--optima-extra-black-italic">Optima LT W01 Extra Black It</div>
                        <CodeDisplay html={`.font--optima-extra-black-italic`} />
                        <div className="style-guide__font font--optima-oblique">Optima LT W01 Oblique</div>
                        <CodeDisplay html={`.font--optima-oblique`} /> */}
                        <hr/>
                        <Subtitle1>Frutiger</Subtitle1>
                        <div className="style-guide__font font--frutiger-light">Frutiger LT W01_45 Ligh1475730</div>
                        <CodeDisplay html={`.font--frutiger-light`} />
                        <div className="style-guide__font font--frutiger-light-alt">Frutiger LT W01_46 Ligh1475734</div>
                        <CodeDisplay html={`.font--frutiger-light-alt`} />
                        <div className="style-guide__font font--frutiger-roman">Frutiger LT W01_55 Roma1475738</div>
                        <CodeDisplay html={`. font--frutiger-roman`} />
                        <div className="style-guide__font font--frutiger-italic">Frutiger LT W01_56 Italic</div>
                        <CodeDisplay html={`.font--frutiger-italic`} />
                        <div className="style-guide__font font--frutiger-bold">Frutiger LT W01_65 Bold1475746</div>
                        <CodeDisplay html={`.font--frutiger-bold`} />
                        <div className="style-guide__font font--frutiger-bold-italic">Frutiger LT W01_66 Bold Italic</div>
                        <CodeDisplay html={`.font--frutiger-bold-italic`} />
                        <div className="style-guide__font font--frutiger-black">Frutiger LT W01_75 Black</div>
                        <CodeDisplay html={`.font--frutiger-black`} />
                        <div className="style-guide__font font--frutiger-black-alt">Frutiger LT W01_76 Blac1475758</div>
                        <CodeDisplay html={`.font--frutiger-black-alt`} />
                        <div className="style-guide__font font--frutiger-black-cn">Frutiger LT W01_87 X Black Cn</div>
                        <CodeDisplay html={`.font--frutiger-black-cn`} />
                        <div className="style-guide__font font--frutiger-black-cn-italic">Frutiger LT W01_88 X Blk Cn It</div>
                        <CodeDisplay html={`.font--frutiger-black-cn-italic`} />
                        {/* <div className="style-guide__font font--optima-nova-demi">Optima nova LT W01 Demi</div>        
                        <CodeDisplay html={`.font--optima-nova-demi`} /> */}
                    </Container>
                </Section>
            </Fragment>
        )
    }
}

class StyleGuideNodes extends Component {
    state = {
        textField: '',
        textFieldWithValue: 'Lorem Ipsum',
        textFieldPlaceholder: '',
        select: '',
        selectWithValue: 'Banana',
        selectPlaceholder: '',
        textArea: '',
        textAreaWithValue: 'Lorem Ipsum',
        textAreaPlaceholder: '',
    }

    handleStateChange = property => e => this.setState({ [property]: e.target.value })

    render() {
        return (
            <Fragment>
                <Section>
                    <Container>
                        <H1>Nodes</H1>
                        <Body1>
                            Nodes are the most basic UI elements that the user can interact with. These include the simplest elements like: buttons, inputs, typography, etc.
                        </Body1>
                    </Container>
                </Section>
                <Section id="style-guide__nodes__inputs">
                    <Container>
                        <H3>Inputs</H3>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>TextField</th>
                                    <th>Select</th>
                                    <th>TextArea</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>Default</th>
                                    <td><TextField label="Test" value={this.state.textField} onChange={this.handleStateChange('textField')} /></td>
                                    <td><Select label="Test" value={this.state.select} onChange={this.handleStateChange('select')} options={['Apple', 'Orange', 'Banana']} /></td>
                                    <td><TextArea label="Test" rows="3" value={this.state.textArea} onChange={this.handleStateChange('textArea')} /></td>
                                </tr>
                                <tr>
                                    <th>With Value</th>
                                    <td><TextField label="Test" value={this.state.textFieldWithValue} onChange={this.handleStateChange('textFieldWithValue')} /></td>
                                    <td><Select label="Test" value={this.state.selectWithValue} onChange={this.handleStateChange('selectWithValue')} options={['Apple', 'Orange', 'Banana']} /></td>
                                    <td><TextArea label="Test" rows="3" value={this.state.textAreaWithValue} onChange={this.handleStateChange('textAreaWithValue')} /></td>
                                </tr>
                                <tr>
                                    <th>Placeholder</th>
                                    <td><TextField label="Test" placeholder="placeholder..." value={this.state.textFieldPlaceholder} onChange={this.handleStateChange('textFieldPlaceholder')} /></td>
                                    <td><Select label="Test" placeholder="Pick a fruit..." value={this.state.selectPlaceholder} onChange={this.handleStateChange('selectPlaceholder')} options={['Apple', 'Orange', 'Banana']} /></td>
                                    <td><TextArea label="Test" rows="3" placeholder="placeholder..." value={this.state.textAreaPlaceholder} onChange={this.handleStateChange('textAreaPlaceholder')} /></td>
                                </tr>
                                <tr>
                                    <th>Default (Disabled)</th>
                                    <td><TextField label="Test" disabled value={this.state.textField} onChange={this.handleStateChange('textField')} /></td>
                                    <td><Select label="Test" disabled value={this.state.select} onChange={this.handleStateChange('select')} options={['Apple', 'Orange', 'Banana']} /></td>
                                    <td><TextArea label="Test" disabled rows="3" value={this.state.textArea} onChange={this.handleStateChange('textArea')} /></td>
                                </tr>
                                <tr>
                                    <th>With Value (Disabled)</th>
                                    <td><TextField label="Test" disabled value={this.state.textFieldWithValue} onChange={this.handleStateChange('textFieldWithValue')} /></td>
                                    <td><Select label="Test" disabled value={this.state.selectWithValue} onChange={this.handleStateChange('selectWithValue')} options={['Apple', 'Orange', 'Banana']} /></td>
                                    <td><TextArea label="Test" disabled rows="3" value={this.state.textAreaWithValue} onChange={this.handleStateChange('textAreaWithValue')} /></td>
                                </tr>
                                <tr>
                                    <th>Placeholder (Disabled)</th>
                                    <td><TextField label="Test" disabled placeholder="placeholder..." value={this.state.textFieldPlaceholder} onChange={this.handleStateChange('textFieldPlaceholder')} /></td>
                                    <td><Select label="Test" disabled placeholder="Pick a fruit..." value={this.state.selectPlaceholder} onChange={this.handleStateChange('selectPlaceholder')} options={['Apple', 'Orange', 'Banana']} /></td>
                                    <td><TextArea label="Test" disabled rows="3" placeholder="placeholder..." value={this.state.textAreaPlaceholder} onChange={this.handleStateChange('textAreaPlaceholder')} /></td>
                                </tr>
                            </tbody>
                        </table>
                    </Container>
                </Section>
                <Section id="style-guide__nodes__toggles">
                    <Container>
                        <H3>Toggles</H3>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td><Toggle type="radio" checked>Radio On</Toggle></td>
                                    <td><Toggle type="radio">Radio Off</Toggle></td>
                                    <td><Toggle type="radio" checked disabled>Radio On(Disabled)</Toggle></td>
                                    <td><Toggle type="radio" disabled>Radio Off(Disabled)</Toggle></td>
                                </tr>
                                <tr>
                                    <td><Toggle type="checkbox" checked>Checkbox On</Toggle></td>
                                    <td><Toggle type="checkbox">Checkbox Off</Toggle></td>
                                    <td><Toggle type="checkbox" checked disabled>Checkbox On(Disabled)</Toggle></td>
                                    <td><Toggle type="checkbox" disabled>Checkbox Off(Disabled)</Toggle></td>
                                </tr>
                                <tr>
                                    <td><Toggle type="switch" checked>Switch On</Toggle></td>
                                    <td><Toggle type="switch">Switch Off</Toggle></td>
                                    <td><Toggle type="switch" checked disabled>Switch On(Disabled)</Toggle></td>
                                    <td><Toggle type="switch" disabled>Switch Off(Disabled)</Toggle></td>
                                </tr>
                            </tbody>
                        </table>
                    </Container>
                </Section>
                <Section id="style-guide__nodes__buttons">
                    <Container>
                        <H3>Buttons</H3>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Default</th>
                                    <th>Raised</th>
                                    <th>Outlined</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>Text Only</th>
                                    <td><Button>Button</Button></td>
                                    <td><Button raised>Button</Button></td>
                                    <td><Button outlined>Button</Button></td>
                                </tr>
                                <tr>
                                    <th>Leading Icon</th>
                                    <td><Button><Icon>favorite</Icon><span>Button</span></Button></td>
                                    <td><Button raised><Icon>favorite</Icon><span>Button</span></Button></td>
                                    <td><Button outlined><Icon>favorite</Icon><span>Button</span></Button></td>
                                </tr>
                                <tr>
                                    <th>Trailing Icon</th>
                                    <td><Button><span>Button</span><Icon>favorite</Icon></Button></td>
                                    <td><Button raised><span>Button</span><Icon>favorite</Icon></Button></td>
                                    <td><Button outlined><span>Button</span><Icon>favorite</Icon></Button></td>
                                </tr>
                                <tr>
                                    <th>Secondary</th>
                                    <td><Button secondary><span>Button</span><Icon>favorite</Icon></Button></td>
                                    <td><Button secondary raised><span>Button</span><Icon>favorite</Icon></Button></td>
                                    <td><Button secondary outlined><span>Button</span><Icon>favorite</Icon></Button></td>
                                </tr>
                                <tr>
                                    <th>Text Only (Disabled)</th>
                                    <td><Button disabled>Button</Button></td>
                                    <td><Button disabled raised>Button</Button></td>
                                    <td><Button disabled outlined>Button</Button></td>
                                </tr>
                                <tr>
                                    <th>Leading Icon (Disabled)</th>
                                    <td><Button disabled><Icon>favorite</Icon><span>Button</span></Button></td>
                                    <td><Button disabled raised><Icon>favorite</Icon><span>Button</span></Button></td>
                                    <td><Button disabled outlined><Icon>favorite</Icon><span>Button</span></Button></td>
                                </tr>
                                <tr>
                                    <th>Trailing Icon (Disabled)</th>
                                    <td><Button disabled><span>Button</span><Icon>favorite</Icon></Button></td>
                                    <td><Button disabled raised><span>Button</span><Icon>favorite</Icon></Button></td>
                                    <td><Button disabled outlined><span>Button</span><Icon>favorite</Icon></Button></td>
                                </tr>
                                <tr>
                                    <th>Secondary (Disabled)</th>
                                    <td><Button secondary disabled><span>Button</span><Icon>favorite</Icon></Button></td>
                                    <td><Button secondary disabled raised><span>Button</span><Icon>favorite</Icon></Button></td>
                                    <td><Button secondary disabled outlined><span>Button</span><Icon>favorite</Icon></Button></td>
                                </tr>
                            </tbody>
                        </table>
                    </Container>
                </Section>
                <Section id="style-guide__nodes__menus">
                    <Container>
                        <H3>Menus</H3>
                        <Menu handle={<Button raised>Open Menu</Button>}>
                            <a href="/">Apple</a>
                            <a href="/">Orange</a>
                            <a href="/">Banana</a>
                        </Menu>
                    </Container>
                </Section>
                <Section id="style-guide__nodes__typography">
                    <Container>
                        <H3>Typography</H3>
                        <Overline>H1:</Overline>
                        <H1>The quick brown fox jumps over the lazy dog</H1>
                        <CodeDisplay html={`<H1>The quick brown fox jumps over the lazy dog</H1>`}/><br /><br />
                        <Overline>H2:</Overline>
                        <H2>The quick brown fox jumps over the lazy dog</H2> 
                        <CodeDisplay html={`<H2>The quick brown fox jumps over the lazy dog</H2>`}/><br /><br />
                        <Overline>H3:</Overline>
                        <H3>The quick brown fox jumps over the lazy dog</H3> 
                        <CodeDisplay html={`<H3>The quick brown fox jumps over the lazy dog</H3>`}/><br /><br />
                        <Overline>H4:</Overline>
                        <H4>The quick brown fox jumps over the lazy dog</H4> 
                        <CodeDisplay html={`<H4>The quick brown fox jumps over the lazy dog</H4>`}/><br /><br />
                        <Overline>H5:</Overline>
                        <H5>The quick brown fox jumps over the lazy dog</H5> 
                        <CodeDisplay html={`<H5>The quick brown fox jumps over the lazy dog</H5>`}/><br /><br />
                        <Overline>H6:</Overline>
                        <H6>The quick brown fox jumps over the lazy dog</H6>
                        <CodeDisplay html={`<H6>The quick brown fox jumps over the lazy dog</H6>`}/><br /><br />
                        <Overline>Subtitle1:</Overline>
                        <Subtitle1>The quick brown fox jumps over the lazy dog</Subtitle1>
                        <CodeDisplay html={`<Subtitle1>The quick brown fox jumps over the lazy dog</Subtitle1>`}/><br /><br />
                        <Overline>Subtitle2:</Overline>
                        <Subtitle2>The quick brown fox jumps over the lazy dog</Subtitle2>
                        <CodeDisplay html={`<Subtitle2>The quick brown fox jumps over the lazy dog</Subtitle2>`}/><br /><br />
                        <Overline>Body1:</Overline>
                        <Body1>The quick brown fox jumps over the lazy dog</Body1>
                        <CodeDisplay html={`<Body1>The quick brown fox jumps over the lazy dog</Body1>`}/><br /><br />
                        <Overline>Body2:</Overline>
                        <Body2>The quick brown fox jumps over the lazy dog</Body2>
                        <CodeDisplay html={`<Body2>The quick brown fox jumps over the lazy dog</Body2>`}/><br /><br />
                        <Overline>Caption:</Overline><br />
                        <Caption>The quick brown fox jumps over the lazy dog</Caption><br />
                        <CodeDisplay html={`<Caption>The quick brown fox jumps over the lazy dog</Caption>`}/><br /><br />
                        <Overline>ButtonText:</Overline><br />
                        <ButtonText>The quick brown fox jumps over the lazy dog</ButtonText><br />
                        <CodeDisplay html={`<ButtonText>The quick brown fox jumps over the lazy dog</ButtonText>`}/><br /><br />
                        <Overline>Overline:</Overline><br />
                        <Overline>The quick brown fox jumps over the lazy dog</Overline><br />
                        <CodeDisplay html={`<Overline>The quick brown fox jumps over the lazy dog</Overline>`}/>
                    </Container>
                </Section>
                <Section id="style-guide__nodes__icons">
                    <Container>
                        <H3>Icons</H3>
                        <Body1>
                            We’re using the Material Design Icon set. Below are some of the more useful icons. A complete list of Icons can be found <a href="https://material.io/tools/icons/?style=baseline" target="_blank" rel="noreferrer">here</a>.
                        </Body1>
                        <div className="grid">
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>favorite</Icon>
                                <Overline>favorite</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>favorite_border</Icon>
                                <Overline>favorite_border</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>star_border</Icon>
                                <Overline>star_border</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>star_half</Icon>
                                <Overline>star_half</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>star</Icon>
                                <Overline>star</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>search</Icon>
                                <Overline>search</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>settings</Icon>
                                <Overline>settings</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>zoom_in</Icon>
                                <Overline>zoom_in</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>zoom_out</Icon>
                                <Overline>zoom_out</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>error</Icon>
                                <Overline>error</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>warning</Icon>
                                <Overline>warning</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>chat</Icon>
                                <Overline>chat</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>email</Icon>
                                <Overline>email</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>add</Icon>
                                <Overline>add</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>add_circle</Icon>
                                <Overline>add_circle</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>add_circle_outline</Icon>
                                <Overline>add_circle_outline</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>remove</Icon>
                                <Overline>remove</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>clear</Icon>
                                <Overline>clear</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>create</Icon>
                                <Overline>create</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>attach_file</Icon>
                                <Overline>attach_file</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>chevron_left</Icon>
                                <Overline>chevron_left</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>chevron_right</Icon>
                                <Overline>chevron_right</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>expand_more</Icon>
                                <Overline>expand_more</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>expand_less</Icon>
                                <Overline>expand_less</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>fullscreen</Icon>
                                <Overline>fullscreen</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>fullscreen_exit</Icon>
                                <Overline>fullscreen_exit</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>menu</Icon>
                                <Overline>menu</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>more_horiz</Icon>
                                <Overline>more_horiz</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>more_vert</Icon>
                                <Overline>more_vert</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <Icon>refresh</Icon>
                                <Overline>refresh</Overline>
                            </div>
                        </div>
                        <CodeDisplay html={`<Icon>favorite</Icon>`}/>
                        <H3>Custom icons</H3>
                        <Body1>
                            Custom CDL Icons are used via the CustomIcon component.
                        </Body1>
                        <div className="grid">
                            <div className="grid__cell--1 style-guid__icon">
                                <CustomIcon>check</CustomIcon>
                                <Overline>check</Overline>
                            </div>
                            <div className="grid__cell--1 style-guid__icon">
                                <CustomIcon>copy</CustomIcon>
                                <Overline>check</Overline>
                            </div>
                        </div>
                        <CodeDisplay html={`<CustomIcon>check</CustomIcon>`}/>
                    </Container>
                </Section>
                <Section id="style-guide__nodes__grid">
                    <Container>
                        <H3>Grid</H3>
                        <div className="grid">
                            <div className="grid__cell--1 chartreuse">1</div>
                            <div className="grid__cell--1 chartreuse">1</div>
                            <div className="grid__cell--1 chartreuse">1</div>
                            <div className="grid__cell--1 chartreuse">1</div>
                            <div className="grid__cell--1 chartreuse">1</div>
                            <div className="grid__cell--1 chartreuse">1</div>
                            <div className="grid__cell--1 chartreuse">1</div>
                            <div className="grid__cell--1 chartreuse">1</div>
                            <div className="grid__cell--1 chartreuse">1</div>
                            <div className="grid__cell--1 chartreuse">1</div>
                            <div className="grid__cell--1 chartreuse">1</div>
                            <div className="grid__cell--1 chartreuse">1</div>
                            
                            <div className="grid__cell--2 green">2</div>
                            <div className="grid__cell--2 green">2</div>
                            <div className="grid__cell--2 green">2</div>
                            <div className="grid__cell--2 green">2</div>
                            <div className="grid__cell--2 green">2</div>
                            <div className="grid__cell--2 green">2</div>
                            
                            <div className="grid__cell--3 spring-green">3</div>
                            <div className="grid__cell--3 spring-green">3</div>
                            <div className="grid__cell--3 spring-green">3</div>
                            <div className="grid__cell--3 spring-green">3</div>
                            
                            <div className="grid__cell--4 cyan">4</div>
                            <div className="grid__cell--4 cyan">4</div>
                            <div className="grid__cell--4 cyan">4</div>
                            
                            <div className="grid__cell--5 azure">5</div>
                            <div className="grid__cell--5 azure">5</div>
                            <div className="grid__cell--2 azure">2</div>
                            
                            <div className="grid__cell--6 blue">6</div>
                            <div className="grid__cell--6 blue">6</div>
                            
                            <div className="grid__cell--7 purple">7</div>
                            <div className="grid__cell--5 purple">5</div>
                            
                            <div className="grid__cell--8 magenta">8</div>
                            <div className="grid__cell--4 magenta">4</div>
                            
                            <div className="grid__cell--9 rose">9</div>
                            <div className="grid__cell--3 rose">3</div>
                            
                            <div className="grid__cell--10 red">10</div>
                            <div className="grid__cell--2 red">2</div>
                            
                            <div className="grid__cell--11 orange">11</div>
                            <div className="grid__cell--1 orange">1</div>
                            
                            <div className="grid__cell--12 yellow">12</div>
                        </div>
                        <CodeDisplay html={
`<div className="grid">
    <!-- 1st row -->
    <div className="grid__cell--1 chartreuse">1</div>
    <div className="grid__cell--1 chartreuse">1</div>
    <div className="grid__cell--1 chartreuse">1</div>
    <div className="grid__cell--1 chartreuse">1</div>
    <div className="grid__cell--1 chartreuse">1</div>
    <div className="grid__cell--1 chartreuse">1</div>
    <div className="grid__cell--1 chartreuse">1</div>
    <div className="grid__cell--1 chartreuse">1</div>
    <div className="grid__cell--1 chartreuse">1</div>
    <div className="grid__cell--1 chartreuse">1</div>
    <div className="grid__cell--1 chartreuse">1</div>
    <div className="grid__cell--1 chartreuse">1</div>
    
    <!-- 2nd row -->
    <div className="grid__cell--2 green">2</div>
    <div className="grid__cell--2 green">2</div>
    <div className="grid__cell--2 green">2</div>
    <div className="grid__cell--2 green">2</div>
    <div className="grid__cell--2 green">2</div>
    <div className="grid__cell--2 green">2</div>
    
    <!-- 3rd row -->
    <div className="grid__cell--3 spring-green">3</div>
    <div className="grid__cell--3 spring-green">3</div>
    <div className="grid__cell--3 spring-green">3</div>
    <div className="grid__cell--3 spring-green">3</div>
    
    <!-- 4th row -->
    <div className="grid__cell--4 cyan">4</div>
    <div className="grid__cell--4 cyan">4</div>
    <div className="grid__cell--4 cyan">4</div>
    
    <!-- 5th row -->
    <div className="grid__cell--5 azure">5</div>
    <div className="grid__cell--5 azure">5</div>
    <div className="grid__cell--2 azure">2</div>
    
    <!-- 6th row -->
    <div className="grid__cell--6 blue">6</div>
    <div className="grid__cell--6 blue">6</div>
    
    <!-- 7th row -->
    <div className="grid__cell--7 purple">7</div>
    <div className="grid__cell--5 purple">5</div>
    
    <!-- 8th row -->
    <div className="grid__cell--8 magenta">8</div>
    <div className="grid__cell--4 magenta">4</div>
    
    <!-- 9th row -->
    <div className="grid__cell--9 rose">9</div>
    <div className="grid__cell--3 rose">3</div>
    
    <!-- 10th row -->
    <div className="grid__cell--10 red">10</div>
    <div className="grid__cell--2 red">2</div>
    
    <!-- 11th row -->
    <div className="grid__cell--11 orange">11</div>
    <div className="grid__cell--1 orange">1</div>
    
    <!-- 12th row -->
    <div className="grid__cell--12 yellow">12</div>
</div>`} />
                    </Container>
                </Section>
            </Fragment>
        )
    }
}

class StyleGuideWidgets extends Component {
    generateItems = (count) => 
        Array(count)
        .fill()
        .map((_, i) => ({ url: `https://digest.canadiandiscovery.com/sites/default/files/WEBHOST-REMOTE/DRUPAL_PRIVATE_FILES/discovery-digest/2018/resource-play-overview/2018_07_Jul25_RPO_Carium_Oil-${i}.jpg`}))  

    state = {
        dialogOpen: false,
        snackbarOpen: false,
        notificationOpen: false,
        carouselItems: this.generateItems(40),
        popupOpen: false
    }

    render() {
        return (
            <Fragment>
                <Section>
                    <Container>
                        <H1>Widgets</H1>
                        <Body1>Widgets are generic complex functional elements. Generally, widgets are something that would normally require a developer to create. Potentially Utilizing a third-party library.</Body1>
                    </Container>
                </Section>
                <Section id="style-guide__widgets__article-list">
                    <Container>
                        <H3>Article List</H3>
                        <div style={{ width: '400px' }}>
                            <ArticleList
                                title="E&amp;P Analysis"
                                image="https://www.essentra.com/-/media/Images/essentra/Updates/top-producing-oil-wells.jpg?la=en&hash=589DD99FA50CEEF221836DFD427BE0F4C23FCE02"
                                articles={[
                                    {
                                        id: 1,
                                        title: 'January 2019 Monthly Spud Analysis by Zone and Operator',
                                        articleType: 'Monthly Spuds'
                                    },
                                    {
                                        title: 'Q2 2018 Quarterly Production Analysis',
                                        articleType: 'Quarterly Production Analysis'
                                    },
                                    {
                                        title: 'Q4 2018 Quarterly Crown Land Sale Analysis',
                                        articleType: 'Quarterly Land Analysis'
                                    },
                                    {
                                        title: 'Q3 2018 Quarterly Completions Analysis',
                                        articleType: 'Quarterly Completions Analysis'
                                    }
                                ]} />
                        </div>
                    </Container>
                </Section>
                <Section id="style-guide__widgets__carousel">
                    <Container>
                        <H3>Carousel</H3>
                        <Body1>A Carousel is a Collection of Images that can scroll horizontally. It can be controlled by clicking and dragging; or by clicking on the dots below the images.</Body1>
                        <Carousel items={this.state.carouselItems} />
                    </Container>
                </Section>
                <Section id="style-guide__widgets__cdl-map">
                    <Container>
                        <H3>CDL Map</H3>
                        <Body1>A Google Map displaying the CDL Office Location</Body1>
                        <CDLMap />
                        <CodeDisplay html={'<CDLMap />'} />
                    </Container>
                </Section>
                <Section id="style-guide__widgets__collapse">
                    <Container>
                        <H3>Collapse</H3>
                        <Collapse title={<span>This is the <i>Collapse Title</i></span>}>
                            <Body1>This is the Collapse Content.</Body1>
                        </Collapse>
                        <CodeDisplay html={
`<Collapse title={<span>This is the <i>Collapse Title</i></span>}>
    <Body1>This is the Collapse Content.</Body1>
</Collapse>`} />
                        <Collapse 
                            color='#f80'
                            background='#08f'
                            title={<span>This is the <b>Collapse Title</b></span>}>
                            <Body1>This is the Collapse Content.</Body1>
                        </Collapse>
                        <CodeDisplay html={
`<Collapse 
    color='#f80'
    background='#08f'
    title={<span>This is the <b>Collapse Title</b></span>}>
    <Body1>This is the Collapse Content.</Body1>
</Collapse>`} />
                    </Container>
                </Section>
                <Section id="style-guide__widgets__content-display">
                    <Container>
                        <H3>Content Display</H3>
                        <div style={{ display: 'flex' }}>
                            <ContentDisplay 
                                content={{
                                    image: 'https://webfiles.canadiandiscovery.com/public/CDD/articles/images/EP_Production_Feature_Image_rrMTJ8X.jpg',
                                    title: 'Test Production Article',
                                    subtitle: 'Quarterly Production',
                                    authors: ['Jeffrey Horton', 'Meridee Fockler'],
                                    publicationDate: new Date('2019-07-19'),
                                    body: '<b>Lorem ipsum</b> dolor sit amet, consectetur adipiscing elit. Maecenas mollis congue diam, sed placerat lectus vehicula sit amet. Sed blandit tristique tempus. Fusce porta gravida hendrerit. Nunc at ex ipsum. Suspendisse id arcu neque. Donec posuere ipsum eu ante sollicitudin viverra. Phasellus turpis enim, tempor eget blandit ut, efficitur ac sapien. Fusce cursus tellus non felis interdum, ut pulvinar libero congue. Maecenas ultrices commodo turpis. Sed bibendum, tortor a ultrices tempus, justo ligula interdum turpis, eget posuere nisl nibh at nunc.'
                                }}/>
                            <ContentDisplay 
                                content={{
                                    image: 'https://webfiles.canadiandiscovery.com/public/CDD/articles/images/EP_Production_Feature_Image_rrMTJ8X.jpg',
                                    title: 'Test Production Article',
                                    subtitle: 'Quarterly Production',
                                    authors: ['Jeffrey Horton', 'Meridee Fockler'],
                                    publicationDate: new Date('2019-07-19'),
                                    body: '<b>Lorem ipsum</b> dolor sit amet, consectetur adipiscing elit. Maecenas mollis congue diam, sed placerat lectus vehicula sit amet. Sed blandit tristique tempus. Fusce porta gravida hendrerit. Nunc at ex ipsum. Suspendisse id arcu neque. Donec posuere ipsum eu ante sollicitudin viverra. Phasellus turpis enim, tempor eget blandit ut, efficitur ac sapien. Fusce cursus tellus non felis interdum, ut pulvinar libero congue. Maecenas ultrices commodo turpis. Sed bibendum, tortor a ultrices tempus, justo ligula interdum turpis, eget posuere nisl nibh at nunc.'
                                }}/>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <ContentDisplay 
                                content={{
                                    image: 'https://webfiles.canadiandiscovery.com/public/CDD/articles/images/EP_Production_Feature_Image_rrMTJ8X.jpg',
                                    title: 'Test Production Article',
                                    subtitle: 'Quarterly Production',
                                    authors: ['Jeffrey Horton', 'Meridee Fockler'],
                                    publicationDate: new Date('2019-07-19'),
                                    body: '<b>Lorem ipsum</b> dolor sit amet, consectetur adipiscing elit. Maecenas mollis congue diam, sed placerat lectus vehicula sit amet. Sed blandit tristique tempus. Fusce porta gravida hendrerit. Nunc at ex ipsum. Suspendisse id arcu neque. Donec posuere ipsum eu ante sollicitudin viverra. Phasellus turpis enim, tempor eget blandit ut, efficitur ac sapien. Fusce cursus tellus non felis interdum, ut pulvinar libero congue. Maecenas ultrices commodo turpis. Sed bibendum, tortor a ultrices tempus, justo ligula interdum turpis, eget posuere nisl nibh at nunc.'
                                }}/>
                            <ContentDisplay 
                                content={{
                                    image: 'https://webfiles.canadiandiscovery.com/public/CDD/articles/images/EP_Production_Feature_Image_rrMTJ8X.jpg',
                                    title: 'Test Production Article',
                                    subtitle: 'Quarterly Production',
                                    authors: ['Jeffrey Horton', 'Meridee Fockler'],
                                    publicationDate: new Date('2019-07-19'),
                                    body: '<b>Lorem ipsum</b> dolor sit amet, consectetur adipiscing elit. Maecenas mollis congue diam, sed placerat lectus vehicula sit amet. Sed blandit tristique tempus. Fusce porta gravida hendrerit. Nunc at ex ipsum. Suspendisse id arcu neque. Donec posuere ipsum eu ante sollicitudin viverra. Phasellus turpis enim, tempor eget blandit ut, efficitur ac sapien. Fusce cursus tellus non felis interdum, ut pulvinar libero congue. Maecenas ultrices commodo turpis. Sed bibendum, tortor a ultrices tempus, justo ligula interdum turpis, eget posuere nisl nibh at nunc.'
                                }}/>
                        </div>
                    </Container>
                </Section>
                <Section id="style-guide__widgets__dialogs">
                    <Container>
                        <H3>Dialogs</H3>
                        <Body1>A Dialog is a notification that appears in the center of the screen covering the rest of the site. Clicking outside of the Dialog will close it.</Body1>
                        <Body1>Use Dialogs when user action must be taken before they can continue using the site. e.g. login forms, contact forms, confirmation request, etc.</Body1>
                        <Button raised onClick={() => this.setState({ dialogOpen: true })}>Open Dialog</Button>
                        <Dialog
                            open={this.state.dialogOpen}
                            onClose={() => this.setState({ dialogOpen: false })}>
                            <div style={{ 'textAlign': 'center' }}>
                                <H1>Hi, I'm a Dialog!</H1>
                                <Body1>You can put any content you want into a dialog.</Body1>
                                <Body2>Click outside to close me.</Body2>
                            </div>
                        </Dialog>
                    </Container>
                </Section>
                <Section id="style-guide__widgets__loader">
                    <Container>
                        <H3>Loader</H3>
                        <Loader />
                        <CodeDisplay html={'<Loader />'} />
                        <Loader text="Printing" />
                        <CodeDisplay html={'<Loader text="Printing" />'} />
                    </Container>
                </Section>
                <Section id="style-guide__widgets__image-link">
                    <Container>
                        <H3>Image Link</H3>
                        <Body1></Body1>
                        <div className="flex"
                            style={{
                                maxWidth: '500px',
                                margin: '0 auto 16px'
                            }}>
                            <ImageLink
                                href="/about"
                                src="http://files-test.canadiandiscovery.com/public/CDL/consulting_manda.jpg"
                                title="Internal Link" />
                            <ImageLink
                                href="https://google.com"
                                src="https://static.boredpanda.com/blog/wp-content/uploads/2018/10/cutest-puppy-dog-pictures-coverimage.jpg"
                                title="External Link" />
                        </div>
                        <CodeDisplay html={
`// NOTE: A ImageLink will be considered an external link if the 'href' property starts with http.
<ImageLink
    href="/about"
    src="http://files-test.canadiandiscovery.com/public/CDL/consulting_manda.jpg"
    title="Internal Link" />
<ImageLink
    href="https://google.com"
    src="https://static.boredpanda.com/blog/wp-content/uploads/2018/10/cutest-puppy-dog-pictures-coverimage.jpg"
    title="External Link" />`} />
                    </Container>
                </Section>
                <Section id="style-guide__widgets__notifications">
                    <Container>
                        <H3>Notifications</H3>
                        <Body1>A Notification is a bar that runs the bottom of the app; with a message to the user and a confirmation button.</Body1>
                        <Body1>Use a Notification when you want to send a message to the user that they have to interact with to remove. e.g. Cookie Consent</Body1>
                        <Button raised onClick={() => this.setState({ notificationOpen: true })}>Open Notification</Button>
                        <Notification
                            open={this.state.notificationOpen}
                            onClose={() => this.setState({ notificationOpen: false })}>Notification</Notification>
                    </Container>
                </Section>
                <Section id="style-guide__widgets__popup">
                    <Container>
                        <H3>Popup</H3>
                        <Body1>Popups are built for displaying information to a use that needs to persist until the user decides to close it. They are movable as to not get in the way of other content.</Body1>
                        { this.state.popupOpen && (
                            <Popup title="This is a <b>Popup</b> title"
                                initialPosition={{ x: 500, y: 300 }}
                                onClose={() => this.setState({ popupOpen: false })}>
                                <div>This is a Popup body</div>
                            </Popup>)}
                        <Button raised onClick={() => this.setState({ popupOpen: true })}>Open Popup</Button>
                    </Container>
                </Section>
                <Section id="style-guide__widgets__fab">
                    <Container>
                        <H3>Fab</H3>
                        <Body1>A Floating Action Button(Fab), as the name suggests, is a button that floats in the bottom right corner of the screen.</Body1>
                        <Body1>Use a Fab for to access primary action on a page. In general for us this will be to access the search functionality of our sites.</Body1>
                        <Body2>(Note: the Fab is the button with a heart on it in the bottom right corner)</Body2>
                        <Fab>favorite</Fab>
                    </Container>
                </Section>
                <Section id="style-guide__widgets__share">
                    <Container>
                        <H3>Share</H3>
                        <Body1>Renders Social media sharing buttons. Pass the title as the text to be shared, and the url of the page you want shared.</Body1>
                        <Share title="This is the text that will be shared" url="https://catalyst.canadiandiscovery.com/info" /><br />
                        <CodeDisplay html={'<Share title="This is the text that will be shared" url="https://google.ca" />'} />
                    </Container>
                </Section>
                <Section id="style-guide__widgets__snackbar">
                    <Container>
                        <H3>Snackbar</H3>
                        <Body1>A Snackbar is a small box that appears in the bottom-left corner of the site, containing short message to for the user. The Snackbar can be manually dismissed by the user, but it will disappear by itself after a few seconds.</Body1>
                        <Body1>Use the Snackbar for non-critical messages to the user. e.g. ‘Email Sent’ or ‘Text Copied to Clipboard’</Body1>
                        <Body1>Snackbars <b>should not</b> be used for error messages.</Body1>
                        <Button raised onClick={() => this.setState({ snackbarOpen: true })}>Open Snackbar</Button>
                        <Snackbar
                            open={this.state.snackbarOpen}
                            onClose={() => this.setState({ snackbarOpen: false })}>
                            I'm a Snackbar!
                        </Snackbar>
                    </Container>
                </Section>
                <Section id="style-guide__widgets__tabs">
                    <Container>
                        <H3>Tabs</H3>
                        <Body1>
                            {"Tabs allow you to have multiple pieces of content share the same space on a screen. A set of <Tab> components must be wrapped in a <Tabs> component to function properly. The color and fontColor of each <Tab> can be independently customized, the default tab color is black(#000)."}
                        </Body1>
                        <Tabs>
                            <Tab title="Catalyst" color="#f2bf1e">
                                I'm Catalyst Body Content
                            </Tab>
                            <Tab title="Discovery Digest" color="#0796ce">
                                I'm Discovery Digest Body Content
                            </Tab>
                            <Tab title="Digest <i>Spark</i>" color="#f07c21">
                                I'm Digest Spark Body Content
                            </Tab>
                            <Tab title="Technical Studies" color="#e51b24" fontColor="cyan">
                                I'm Technical Studies Body Content
                            </Tab>
                        </Tabs>
                        <CodeDisplay html={
`<Tabs>
    <Tab title="Catalyst" color="#f2bf1e">
        I'm Catalyst Body Content
    </Tab>
    <Tab title="Discovery Digest" color="#0796ce">
        I'm Discovery Digest Body Content
    </Tab>
    <Tab title="Digest <i>Spark</i>" color="#f07c21">
        I'm Digest Spark Body Content
    </Tab>
    <Tab title="Technical Studies" color="#e51b24" fontColor="cyan">
        I'm Technical Studies Body Content
    </Tab>
</Tabs>`} />
                    </Container>
                </Section>
            </Fragment>
        )
    }
}

class StyleGuideFeatures extends Component {
    render() {
        return (
            <Fragment>
                <Section>
                    <Container>
                        <H1>Features</H1>
                        <Body1>
                            Features are less generic Widgets. Often a feature will communicate with the server; whether it needs to pull data from a api, or send a request to log data/send an email.
                        </Body1>
                    </Container>
                </Section>
                <Section id="style-guide__features__contact">
                    <Container>
                        <H3>Contact</H3>
                        <Body1></Body1>
                        <Contact title="Test Contact Form"
                            topic="Contact Form"                            
                            fields={[
                                { name: 'First Name', type: 'text', required: true, span: '6' },
                                { name: 'Last Name', type: 'text', required: true, span: '6' },
                                { name: 'Email', type: 'email', required: true, span: '12', title: 'ex. example@email.com' },
                                { name: 'Phone', type: 'tel', span: '12', title: 'ex. example@email.com' },
                                { name: 'Message', type: 'textarea', required: true, span: '12' }
                            ]}
                            instructions={[
                                'Complete and submit this form.',
                                'A member of our client relations team will get in touch with you to discuss details and to book a demo.',
                                'Subscribe to the Discovery Digest and unlock access to thousands of articles and geological maps!'
                            ]} /> 
                        <br />
                        <CodeDisplay html={
`<Contact  title="Test Contact Form"
    topic="Contact Form"                            
    fields={[
        { name: 'First Name', type: 'text', required: true, span: '6' },
        { name: 'Last Name', type: 'text', required: true, span: '6' },
        { name: 'Email', type: 'email', required: true, span: '12', title: 'ex. example@email.com' },
        { name: 'Phone', type: 'tel', span: '12', title: 'ex. example@email.com' },
        { name: 'Message', type: 'textarea', required: true, span: '12' }
    ]}
    instructions={[
        'Complete and submit this form.',
        'A member of our client relations team will get in touch with you to discuss details and to book a demo.',
        'Subscribe to the Discovery Digest and unlock access to thousands of articles and geological maps!'
    ]} />`} />
                    </Container>
                </Section>
                <Section id="style-guide__features__faq">
                    <Container>
                        <H3>FAQ</H3>
                        <Body1></Body1>
                        <Faq background="#e0e0e0" color="#656565" />
                        <CodeDisplay html={'<Faq background="#e0e0e0" color="#656565" />'} />
                    </Container>
                </Section>
                <Section id="style-guide__features__email-optin">
                    <Container>
                        <H3>Email Optin</H3>
                        <Body1></Body1>
                        <div style={{ width: '300px' }}>
                            <EmailOptin
                                message="Sign-up for weekly email alerts"
                                successMessage="Sign-up Successful"
                                role="Mail-9-Articles" />
                        </div>
                        <br />
                        <CodeDisplay html={
`<EmailOptin
    message="Sign-up for weekly email alerts"
    successMessage="Sign-up Successful"
    role="Mail-9-Articles" />`} />
                    </Container>
                </Section>
                <Section id="style-guide__features__check-subscription">
                    <Container>
                        <H3>Check Subscription</H3>
                        <Body1></Body1>
                        <div style={{ width: '300px' }}>
                            <CheckSubscription
                                productName="Canadian Discovery's Discovery Digest"
                                role="CDD" />
                        </div>
                        <br />
                        <CodeDisplay html={
`<CheckSubscription
    productName="Canadian Discovery's Discovery Digest"
    role="CDD" />`} />
                    </Container>
                </Section>
                <Section id="style-guide__features__edit-button">
                    <Container>
                        <H3>Edit Button</H3>
                        <EditButton href="https://canadiandiscovery.com" />
                        <br />
                        <br />
                        <CodeDisplay html={`<EditButton href="https://canadiandiscovery.com" />`} />
                    </Container>
                </Section>
                {this.props.features || null}
            </Fragment>
        )
    }
}

class StyleGuide extends Component {
    render() {
        return (
            <Tabs>
                <Tab title="Atoms" icon="trip_origin">
                    <StyleGuideAtoms />
                </Tab>
                <Tab title="Nodes" icon="bubble_chart">
                    <StyleGuideNodes />
                </Tab>
                <Tab title="Widgets" icon="widgets">
                    <StyleGuideWidgets />
                </Tab>
                <Tab title="Features" icon="select_all">
                    <StyleGuideFeatures features={this.props.features} />
                </Tab>
            </Tabs>
        )
    }
}

export default StyleGuide